export enum SortKeys {
  Status = "status",
  Model = "segment.name",
  Destination = "destination.name",
  LastRunAt = "last_run_at",
  UpdatedAt = "updated_at",
}

export const DEFAULT_SYNC_SORT_KEY = SortKeys.UpdatedAt;
export const SYNC_SORT_OPTIONS = Object.values(SortKeys);

/**
 * Cap on how many segment ids the syncs list will inline into a `segment_id`
 * filter. Past this, filtering through the nested `segment` relationship is
 * the lesser evil.
 */
export const MAX_INLINED_SEGMENT_IDS = 1000;
